<template>
    <div class="partners">
        <div v-for="item in List" :key="item.id">
            <div>
                <img :src="item.picLink" alt="">
            </div>
        </div>
        <!-- <div style="font-weight: bolder; color: black; height: 50px;">晞德软件</div> -->
    </div>
</template>

<script>
import {getPartner} from '../utils/api.js'
import axios from 'axios';
export default {
    name:"co",
    data(){
        return{
            List:[]
        }
    },
    created(){
        this.load()
    },
    methods:{
        load(){
            // getPartner().then(res =>{
            //     // console.log(res)
            //     this.List = res.data
            // })
            axios.get(`${window.baseUrl}/partner/getAllPartner`).then(res=>{
                if(res.data.code == 200){
                    this.List = res.data.data
                }
            }).catch(error => {
                console.error('获取合作伙伴数据失败:', error)
                this.$message.error('获取数据失败，请检查网络连接或联系管理员')
                // 可以设置一些默认数据
                this.List = []
            })
        }
    }
}
</script>

<style>
.partners{
    width: 700px;
    /* height: 120px; */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 20px;
    justify-content: center;
    background-color: rgba(255,255,255,0.4);
    border-radius: 20px;
    padding: 0px 220px;
}
.partners div{
    width: 97px;
    /* height: 70px; */
    /* background: #FFFFFF; */
    /* box-shadow: rgba(235, 231, 231, 0.2) 0px 2px 8px 0px; */
    /* margin-left: 10px; */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 5px;
    padding: 5px;
    
}
.partners div img {
    width: 95%;
    /* height: 50px; */
}
</style>